<template>
  <div>
    <div v-if="!moduleEnabled" class="flexCollumnStart">
      <div class="colorTile">
        <h2>You don't have access to the module.</h2>
      </div>
      <p>
        You don't have privileges to access this module, please contact
        <a :href="helpdeskMailURL">{{ helpdeskMail }}</a> to activate this
        module.
      </p>
      <p>
        More information about this module can be found in the
        <router-link :to="{ name: 'help' }"> StackAssist Help </router-link>
        .
      </p>
    </div>
  </div>
</template>

<script>
import contactInfo from '@/constants/contactInfo'

export default {
  name: 'NoModuleAccessMessage',
  props: ['moduleEnabled'],

  data() {
    return {
      helpdeskMail: contactInfo.mail,
      helpdeskMailURL: `mailto:${contactInfo.mail}`,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.colorTile {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: $secondary;
  border-radius: 0.5rem !important;
  padding: 1rem;
}
</style>
